<template>
	<div class="container">
		<ul class="topicpath">
			<li><a v-link="{ path: '/', exact: true }">TOP</a></li>
			<li><a v-on:click="searchPrefectureLink(profile.address_id)">{{prefecture}}</a></li>
			<li v-if="district"><a v-on:click="searchDistrictLink(district)">{{district}}</a></li>
		</ul>
	</div>
	<script type="application/ld+json" v-text="jsonld"></script>
</template>
<script>
import { searchWordsLink, searchConditions, SCStr } from '../vuex/actions';
import { getPrefecturesList, getDistrict } from '../vuex/getters';
module.exports = {
	vuex: {
		getters: {
			prefecturesList: getPrefecturesList,
			district_obj: getDistrict
		},
		actions: {
			updateSearchWordsLink: searchWordsLink,
			updateSearchConditions: searchConditions,
			setSCStr: SCStr
		}
	},
	data: function(){
		return {
			profile: '',
			prefecture: '',
			district: '',
			jsonld: ''
		};
	},
	created: function() {
		this.$on('resTopicpath', function(obj) {
			this.profile = obj;
			this.prefecture = this.getPrefectures(obj.address_id);
			this.district = obj.ward;

			var listItem = [];
			var root = window.location.origin + '/#!/';

			// TOP
			listItem.push(`{
	"@type": "ListItem",
	"position": 1,
	"item": {
		"@id": "${root}",
		"name": "TOP"
	}
}`);
			// 都道府県
			if (this.prefecture){
				listItem.push(`{
	"@type": "ListItem",
	"position": 2,
	"item": {
		"@id": "${root + 'searchresult?c=sa' + obj.address_id + '%3A1&w='}",
		"name": "${this.prefecture}"
	}
}`);
			}
			// 23区
			if (this.district){
				listItem.push(`{
	"@type": "ListItem",
	"position": 3,
	"item": {
		"@id": "${root + 'searchresult?c=' + this.getDistrictId(obj.ward) + '%3A1&w='}",
		"name": "${obj.ward}"
	}
}`);
			}

			var jsonld = `{
	"@context": "http://schema.org",
	"@type": "BreadcrumbList",
	"itemListElement": [${listItem}]
}`;
			// console.log(jsonld);
			this.jsonld = jsonld;
		});
	},
	ready: function() {
	},
	methods: {
		searchPrefectureLink: function(value){
			// this.updateSearchConditions(this.prefecture);
			// this.setSCStr(str);
			this.$route.router.go({
				name: 'searchresult',
				query: {
					w: '',
					c: 'sa' + value + ':1'
				}
			});
		},
		searchDistrictLink: function(value){
			this.$route.router.go({
				name: 'searchresult',
				query: {
					w: '',
					c: this.getDistrictId(value) + ':1'
				}
			});
		},
		getDistrictId: function(value){
			for (var i in this.district_obj){
				if (this.district_obj[i].name === value){
					return this.district_obj[i].id;
				}
			}
		}
	},
	mixins: [
		require('../mixins/getPrefectures.js'),
		require('../mixins/searchWordLink.js')
	]
};
</script>



// WEBPACK FOOTER //
// topicpath.vue?1b41a41b